module.exports = __webpack_public_path__ + "static/EuclidFlex-Medium-WebS-3fe321b65d836f74e64a6e7e00d6f0ee.woff";